module.exports = __webpack_public_path__ + "components/flag/static/square/vi-7d454627bbec69541c37be69d150e1bb.svg";